import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './GameBox.pcss';

class GameBox extends PureComponent {
    static propTypes = {
        background: PropTypes.string,
        logo: PropTypes.string,
        percent: PropTypes.number,
        className: PropTypes.string,
        hasCustomSize: PropTypes.bool,
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
        onMouseEnter: PropTypes.func,
        onMouseLeave: PropTypes.func
    };

    static defaultProps = {
        percent: null
    };

    render() {
        const {
            background,
            className,
            hasCustomSize,
            logo,
            onClick,
            onMouseEnter,
            onMouseLeave,
            percent,
            disabled
        } = this.props;

        const isUpdating = typeof percent === 'number';
        const percentage = isUpdating && percent.toFixed();
        const wrapperClasses = cx(styles.wrapper, className, {
            [styles.wrapperSize]: !hasCustomSize,
            [styles.updating]: isUpdating
        });
        const bgClasses = cx(styles.contentWrapper, styles.background, styles.bgProgress, {
            [styles.bgMissing]: !background
        });

        return (
            <button
                className={wrapperClasses}
                onClick={onClick}
                disabled={disabled}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}>
                {isUpdating && (
                    <span
                        className={cx(
                            styles.contentWrapper,
                            styles.background,
                            styles.backgroundImage
                        )}
                        style={{backgroundImage: background && `url(${background})`}}
                    />
                )}
                <span
                    className={bgClasses}
                    style={{
                        backgroundImage: background && `url(${background})`,
                        padding: isUpdating && `0 ${100 - percentage}%`
                    }}
                />
                <span className={styles.contentWrapper}>
                    {logo && (
                        <span
                            className={cx(styles.background, styles.logo)}
                            style={{backgroundImage: `url(${logo})`}}
                        />
                    )}
                </span>
                {isUpdating && (
                    <span
                        className={cx(styles.contentWrapper, styles.overlay)}
                        style={{width: `${100 - percentage}%`}}
                    />
                )}
            </button>
        );
    }
}

export default GameBox;
